// extracted by mini-css-extract-plugin
export default {"input":"Input_input__e04Su","label":"Input_label__jL6CD","container":"Input_container__Vma6i"};